/** Characters of a lesson brief a course page shows in place of the whole text. */
const BRIEF_PREVIEW_CHARACTERS = 160;

/**
 * The one line a course page shows for a lesson: its teacher-facing description, else the start of
 * its brief. A brief can be a whole pasted textbook chapter, so it is never shown in full here.
 */
export function lessonSummaryLine(lesson: { brief?: string | null; description?: string | null }): string {
    const description = lesson.description?.trim();
    if (description) return description;
    const brief = (lesson.brief ?? '').replace(/\s+/g, ' ').trim();
    return brief.length > BRIEF_PREVIEW_CHARACTERS ? `${brief.slice(0, BRIEF_PREVIEW_CHARACTERS).trimEnd()}…` : brief;
}
